/**
 * 推荐商品
 */
import React, { FC, useCallback, useState, useEffect, useContext } from 'react'
import { modalLayer, getHistoryNew } from '@utils'
import { observer } from 'mobx-react'
import { Price, ProductImage, Stepper, Tags } from 'components'
import { MallController } from '@ctrls/mallController'
import { classNames } from '@dt/fe-utils'
import Config from 'common/config/config'
import MonthSaleInfo from '../MonthSaleInfo'
import './index.scss'

// interface
interface IProps {
  product: IMallViewProduct;
  style?: any;
}
// 瀑布流图片的宽度
const ProductItem: FC<IProps> = ({ product, style }) => {
  const [defaultImg, setDefault] = useState<string>('')
  let { no, name, price, actualPrice, memberPrice, offPrice, isMemberDiscount } = product || {}
  /** 获得图片的宽高 */
  const [productStyle] = useState(() => {
    const imgWidth = style.width || 128
    const imgHeight = imgWidth
    return {
      width: imgWidth,
      height: imgHeight
    }
  })

  useEffect(() => {
    const imgArr = JSON.parse(product.pics || '[]')
    const defaultItem = imgArr.filter(item => item.default !== 0)
    const defaultImgUrl: string = defaultItem.length ? (defaultItem[0].type === 'video' ? defaultItem[0].videoImageUrl : defaultItem[0].url) : imgArr?.[0]?.url

    setDefault(defaultImgUrl)
  }, [product])

  const handleProductDetail = (product: IMallViewProduct | IViewCartItem) => {
    MallController.goToProduct(product, true)
  }

  return (
    <div
      className={classNames(
        'mall-product-item recommend',
      )}
      style={style}
      onClick={() => handleProductDetail(product)}
    >
      <ProductImage
        type='mall'
        imgSrc={defaultImg}
        width={productStyle.width}
        height={productStyle.height}
      />
      <div className='product-info'>
        <div className='product-name'>{name}</div>
        <div className='product-actions'>
          <Price
            className='product-price'
            price={price}
            actualPrice={actualPrice}
            offPrice={offPrice}
            memberPrice={memberPrice}
            isMemberDiscount={isMemberDiscount}
          />
        </div>
      </div>
    </div>
  )
}
export default observer(ProductItem)
